import { z } from 'zod';
import { AppointmentType } from '@prisma/client';

export const nachversandAppointmentTypes = [
  AppointmentType.NACHVERSAND_BDM1,
  AppointmentType.NACHVERSAND_BDM2,
  AppointmentType.NACHVERSAND_PART2,
] as const;

export const nachversandBookingLinkQueryReqDto = z.object({
  type: z.enum(nachversandAppointmentTypes),
});
export type NachversandBookingLinkQueryReqDto = z.infer<
  typeof nachversandBookingLinkQueryReqDto
>;
export type NachversandAppointmentType =
  NachversandBookingLinkQueryReqDto['type'];

export const isNachversandAppointmentType = (
  type: AppointmentType,
): type is NachversandAppointmentType =>
  (nachversandAppointmentTypes as readonly AppointmentType[]).includes(type);

export const nachversandBookingLinkResDto = z.object({
  url: z.string(),
});
export type NachversandBookingLinkResDto = z.infer<
  typeof nachversandBookingLinkResDto
>;
